import Vue from 'vue';
const audienceRulesUrl = '/audience-rules';

const actionCustomError = (error) => {
  return {
    message: error,
    status: false,
  };
};

export const fetchOrganizationAudienceRules = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      method: 'GET',
      url: audienceRulesUrl,
    });
    commit('setOrganizationAudienceRules', data);
  } catch (error) {
    return actionCustomError(error);
  }
};

/**
 * {event, prublication, benefit}
 */
export const createAudienceRules = async ({ commit }, payload) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: audienceRulesUrl,
      data: payload,
    });
    return {
      status: true,
      data: data
    }
  } catch (error) {
    return actionCustomError(error);
  }
};

export const updateAudienceRule = async ({ commit }, data) => {
  try {
    await Vue.axios({
      method: 'PATCH',
      url: audienceRulesUrl + `/${data.categoryId}`,
      data: data.payload,
    });
  } catch (error) {
    return actionCustomError(error);
  }
};

export const getAudienceRuleByCategoryId = async ({ commit }, id = null) => {
  try {
    if (!id) throw new Error('Error en el sistema');

    const { data } = await Vue.axios({
      method: 'GET',
      url: audienceRulesUrl + `/${id}`,
    });

    return {
      status: true,
      data: {
        branches: data.branches ?? [],
        affiliationTypes: data.affiliationTypes ?? [],
        subgroups: data.subgroups ?? [],
        memberStatus: data.memberStatus ?? [],
      },
    };
  } catch (error) {
    return actionCustomError(error);
  }
};


export const sendEmailsByAudienceRule = async ({commit}, id = null) => {
  try {
    if (!id) throw new Error('Error en el sistema');

    const { data } = await Vue.axios({
      method: 'POST',
      url: audienceRulesUrl + `/send-notification/${id}`
    })

    return {
      status: true,
      data: data
    }
  } catch (error) {
    return actionCustomError(error);
  }
}

/**
 * Devuelve el conteo de miembros que verán un recurso según las reglas
 * { affiliationTypes, branches, subgroups, memberStatus }
 */
export const previewAudienceCount = async ({ commit }, rules = {}) => {
  try {
    const { data } = await Vue.axios({
      method: 'POST',
      url: audienceRulesUrl + '/preview',
      data: {
        affiliationTypes: rules.affiliationTypes || [],
        branches: rules.branches || [],
        subgroups: rules.subgroups || [],
        memberStatus: rules.memberStatus || [],
      },
    });
    return {
      status: true,
      count: data.count ?? 0,
    };
  } catch (error) {
    return actionCustomError(error);
  }
};